import { useContext, useEffect } from 'react';
import { WP_Service } from '../model/models';
import { useLogger } from '../services/LogService';
import { AppContext } from '../state/AppContextProvider';
import { ActionType } from '../state/GlobalState';
import { useWP } from './WPHooks';

/**
 * Hook useServices()
 * Fetch all services and return it as local sate
 */
export const useServices = () => {
  const { state, dispatch } = useContext(AppContext);

  const { wp, ready } = useWP();

  const logger = useLogger('useServices');

  const fetch = () => {
    // Get all Services
    wp.getServices(state.locale).then((services) => {
      services.sort(function (a: WP_Service, b: WP_Service) {
        return a.menu_order - b.menu_order;
      });
      dispatch({ type: ActionType.SetServicesPages, payload: services });
    });
  };

  useEffect(() => {
    if (ready && state.servicesPages.length === 0) {
      logger.info('useEffect() fetch()');
      fetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ready]);

  return { services: state.servicesPages, fetch: fetch };
};
